/** URL `?tab=` values for leave application overview. */
export const LeaveApplicationOverviewTabParam = {
  OVERVIEW: "overview",
} as const;

export type LeaveApplicationOverviewTabParamValue =
  (typeof LeaveApplicationOverviewTabParam)[keyof typeof LeaveApplicationOverviewTabParam];

const TAB_ID_TO_PARAM: Record<string, LeaveApplicationOverviewTabParamValue> = {
  "1": LeaveApplicationOverviewTabParam.OVERVIEW,
};

const PARAM_TO_TAB_ID: Record<string, string> = {
  [LeaveApplicationOverviewTabParam.OVERVIEW]: "1",
  // Legacy param — redirect to overview
  employee: "1",
};

export function leaveApplicationOverviewTabIdFromSearchParam(
  tab: string | null,
): string {
  if (!tab) return "1";
  return PARAM_TO_TAB_ID[tab] ?? "1";
}

export function searchParamForLeaveApplicationOverviewTabId(
  tabId: string,
): LeaveApplicationOverviewTabParamValue | null {
  return TAB_ID_TO_PARAM[tabId] ?? null;
}

export function isValidLeaveApplicationOverviewTabParam(
  tab: string | null,
): boolean {
  if (!tab) return false;
  return Object.prototype.hasOwnProperty.call(PARAM_TO_TAB_ID, tab);
}
